import React, {useContext, useEffect, useState, useRef} from "react";
import { Link, useNavigate } from "react-router-dom";

import logo from "./../../../Public/img/logo-black.png";
import userlogo from "./../../../Public/img/avatar-14.jpg";
import { AuthContext } from "../../../context/AuthContext";

const Header = () =>{

    const navigate = useNavigate();

    const {user, setUser} = useContext(AuthContext);
    const [showprofiledropdown, setShowProfileDropDown] = useState(false);
    const [loggedname, setLoggedName] = useState("");
    const profiledropdownRef = useRef(null);

    const dashboardurl = `${window.location.origin}/team/dashboard`;

    useEffect(() =>{
    
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event)
        {
            if (profiledropdownRef.current && !profiledropdownRef.current.contains(event.target)) 
            {
                setShowProfileDropDown(false);
            }
        }

    }, []);

    useEffect(()=>{

        const userinfo = localStorage.getItem("userinfo");

        if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
            //console.log('User info===='+loggeduserdata);
            //console.log('User info===='+loggeduserdata.name);
        }

    }, [])


    const handleShowProfileToggle = ()=>{
        setShowProfileDropDown(!showprofiledropdown);
    }

    const handleLogout = () =>{

        //localStorage.removeItem('cpmstoken');
        sessionStorage.removeItem('cpmstoken');
        localStorage.removeItem('userinfo');
        setUser(null);

        navigate('/sign-in', { replace: true });
    }

    return (
        <div className="header">
            <div className="header-left active">
                <Link to={dashboardurl} className="logo logo-normal img-logo">
                    <img src={logo} alt="Logo" />
                    {/*<img src="assets/img/white-logo.svg" className="white-logo" alt="Logo" />*/}
                </Link>
                {/*<Link to="index-2.html" className="logo-small">
                    <img src="assets/img/logo-small.svg" alt="Logo" />
                </Link>
                <Link id="toggle_btn" to="#">
                    <i className="ti ti-arrow-bar-to-left"></i>
                </Link>*/}
            </div>

            <Link id="mobile_btn" className="mobile_btn" to="#sidebar">
                <span className="bar-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </Link>

            <div className="header-user">
                <ul className="nav user-menu">
                    <li className="nav-item nav-search-inputs me-auto">
                        
                    </li>

                    <li>
                        <div className="sidebar sidebar-horizontal" id="horizontal-single">
                            <div className="sidebar-menu">
                                <div className="main-menu">
                                    <ul className="nav-menu">                                        
                                        <li className="menu-title">
                                            <span>Main</span>
                                        </li>
                                        <li className="submenu">
                                            <a href="javascript:void(0);">
                                                <i className="ti ti-layout-2"></i><span>layouts</span><span className="menu-arrow"></span>
                                            </a>
                                            <ul>
                                                <li>
                                                    <Link to="layout-mini.html">Mini</Link>
                                                </li>
                                                <li>
                                                    <Link to="layout-horizontal-single.html">Horizontal Single</Link>
                                                </li>
                                                <li><Link to="layout-without-header.html">Without Header</Link></li>
                                                <li><Link to="layout-rtl.html">RTL</Link></li>
                                                <li><Link to="layout-detached.html">Detached</Link></li>
                                                <li><Link to="layout-dark.html">Dark</Link></li>
                                            </ul>
                                        </li>
                                        <li className="submenu">
                                            <Link to="javascript:void(0);" className="active">
                                                <i className="ti ti-layout-2"></i>
                                                <span>Dashboard</span>
                                                <span className="menu-arrow"></span>
                                            </Link>
                                            <ul>
                                                <li>
                                                    <Link to="index-2.html">Deals Dashboard</Link>
                                                </li>
                                                <li>
                                                    <Link to="leads-dashboard.html" className="active">Leads Dashboard</Link>
                                                </li>
                                                <li>
                                                    <Link to="project-dashboard.html">Project Dashboard</Link>
                                                </li>
                                                <li className="submenu">
                                                    <Link to="#">
                                                        <i className="ti ti-user-star"></i><span>Super Admin</span>
                                                        <span className="menu-arrow"></span>
                                                    </Link>
                                                    <ul>
                                                        <li>
                                                            <a href="dashboard.html">Dashboard</a>
                                                        </li>
                                                        <li>
                                                            <a href="company.html">Companies</a>
                                                        </li>
                                                        <li>
                                                            <a href="subscription.html">Subscriptions</a>
                                                        </li>
                                                        <li>
                                                            <a href="packages.html">Packages</a>
                                                        </li>
                                                        <li>
                                                            <a href="domain.html">Domain</a>
                                                        </li>
                                                        <li>
                                                            <a href="purchase-transaction.html">Purchase Transaction</a>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="submenu">
                                            <a href="javascript:void(0);"><i className="ti ti-brand-airtable"></i><span>Application</span>
                                                <span className="menu-arrow"></span></a>
                                            <ul>
                                                <li><a href="chat.html">Chat</a></li>
                                                <li className="submenu submenu-two">
                                                    <a href="javascript:void(0);">Call<span className="menu-arrow inside-submenu"></span></a>
                                                    <ul>
                                                        <li><a href="video-call.html">Video Call</a></li>
                                                        <li><a href="audio-call.html">Audio Call</a></li>
                                                        <li><a href="call-history.html">Call History</a></li>
                                                    </ul>
                                                </li>
                                                <li><a href="calendar.html">Calendar</a></li>
                                                <li><a href="email.html">Email</a></li>
                                                <li><a href="todo.html">To Do</a></li>
                                                <li><a href="notes.html">Notes</a></li>
                                                <li><a href="file-manager.html">File Manager</a></li>
                                                <li><a href="social-feed.html">Social Feed</a></li>
                                                <li><a href="kanban-view.html">Kanban</a></li>
                                                <li><a href="invoice.html">Invoices</a></li>
                                            </ul>
                                        </li>
                                        <li className="submenu">
                                            <a href="javascript:void(0);">
                                                <i className="ti ti-layout-2"></i><span>layouts</span><span className="menu-arrow"></span>
                                            </a>
                                            <ul>
                                                <li><a href="layout-mini.html">Mini</a></li>
                                                <li><a href="layout-horizontal-single.html">Horizontal Single</a></li>
                                                <li><a href="layout-without-header.html">Without Header</a></li>
                                                <li><a href="layout-rtl.html">RTL</a></li>
                                                <li><a href="layout-detached.html">Detached</a></li>
                                                <li><a href="layout-dark.html">Dark</a></li>
                                            </ul>
                                        </li>
                                        <li className="submenu">
                                            <a href="#">
                                                <i className="ti ti-ti ti-user-up"></i><span>Crm</span>
                                                <span className="menu-arrow"></span>
                                            </a>
                                            <ul>
                                                <li>
                                                    <a href="contacts.html"><span>Contacts</span></a>
                                                </li>
                                                <li>
                                                    <a href="companies.html"><span>Companies</span></a>
                                                </li>
                                                <li>
                                                    <a href="deals.html"><span>Deals</span></a>
                                                </li>
                                                <li>
                                                    <a href="leads.html"><span>Leads</span></a>
                                                </li>
                                                <li>
                                                    <a href="pipeline.html"><span>Pipeline</span></a>
                                                </li>
                                                <li>
                                                    <a href="campaign.html"><span>Campaign</span></a>
                                                </li>
                                                <li>
                                                    <a href="projects.html"><span>Projects</span></a>
                                                </li>
                                                <li>
                                                    <a href="tasks.html"><span>Tasks</span></a>
                                                </li>
                                                <li>
                                                    <a href="proposals.html"><span>Proposals</span></a>
                                                </li>
                                                <li>
                                                    <a href="contracts.html"><span>Contracts</span></a>
                                                </li>
                                                <li>
                                                    <a href="estimations.html"><span>Estimations</span></a>
                                                </li>
                                                <li>
                                                    <a href="invoices.html"><span>Invoices</span></a>
                                                </li>
                                                <li>
                                                    <a href="payments.html"><span>Payments</span></a>
                                                </li>
                                                <li>
                                                    <a href="analytics.html"><span>Analytics</span></a>
                                                </li>
                                                <li>
                                                    <a href="activities.html"><span>Activities</span></a>
                                                </li>
                                                <li className="submenu">
                                                    <a href="#">
                                                        <span>Crm Settings</span>
                                                        <span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="sources.html"><span>Sources</span></a></li>
                                                        <li><a href="lost-reason.html"><span>Lost Reason</span></a></li>
                                                        <li><a href="contact-stage.html"><span>Contact Stage</span></a></li>
                                                        <li><a href="industry.html"><span>Industry</span></a></li>
                                                        <li><a href="calls.html"><span>Calls</span></a></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="submenu">
                                            <a href="#">
                                                <i className="ti ti-file-invoice"></i><span>Reports</span>
                                                <span className="menu-arrow"></span>
                                            </a>
                                            <ul>
                                                <li><a href="lead-reports.html">Lead Reports</a></li>
                                                <li><a href="deal-reports.html">Deal Reports</a></li>
                                                <li><a href="contact-reports.html">Contact Reports</a></li>
                                                <li><a href="company-reports.html">Company Reports</a></li>
                                                <li><a href="project-reports.html">Project Reports</a></li>
                                                <li><a href="task-reports.html">Task Reports</a></li>
                                            </ul>
                                        </li>
                                        
                                        <li className="submenu">
                                            <a href="#">
                                                <i className="ti ti-page-break"></i><span>Pages</span>
                                                <span className="menu-arrow"></span>
                                            </a>
                                            <ul>
                                                <li><a href="manage-users.html"><span>Manage Users</span></a></li>
                                                <li><a href="roles-permissions.html"><span>Roles & Permissions</span></a></li>
                                                <li><a href="delete-request.html"><span>Delete Request</span></a></li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>Membership</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="membership-plans.html">Membership Plans</a></li>
                                                        <li><a href="membership-addons.html">Membership Addons</a></li>
                                                        <li><a href="membership-transactions.html">Transactions</a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>Location</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="countries.html">Countries</a></li>
                                                        <li><a href="states.html">States</a></li>
                                                        <li><a href="cities.html">Cities</a></li>
                                                    </ul>
                                                </li>
                                                <li><a href="testimonials.html"><span>Testimonials</span></a></li>
                                                <li><a href="faq.html"><span>FAQ</span></a></li>
                                                <li><a href="contact-messages.html"><span>Contact Messages</span></a></li>
                                                <li><a href="tickets.html"><span>Tickets</span></a></li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>Authentication</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="login.html">Login</a></li>
                                                        <li><a href="register.html">Register</a></li>
                                                        <li><a href="forgot-password.html">Forgot Password</a></li>
                                                        <li><a href="reset-password.html">Reset Password</a></li>
                                                        <li><a href="email-verification.html">Email Verification</a></li>
                                                        <li><a href="two-step-verification.html">2 Step Verification</a></li>
                                                        <li><a href="lock-screen.html">Lock Screen</a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>Error Pages</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="error-404.html">404 Error</a></li>
                                                        <li><a href="error-500.html">500 Error</a></li>
                                                    </ul>
                                                </li>
                                                <li><a href="blank-page.html"><span>Blank Page</span></a></li>
                                                <li><a href="coming-soon.html"><span>Coming Soon</span></a></li>
                                                <li><a href="under-maintenance.html"><span>Under Maintenance</span></a></li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>Base UI</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="ui-alerts.html">Alerts</a></li>
                                                        <li><a href="ui-accordion.html">Accordion</a></li>
                                                        <li><a href="ui-avatar.html">Avatar</a></li>
                                                        <li><a href="ui-badges.html">Badges</a></li>
                                                        <li><a href="ui-borders.html">Border</a></li>
                                                        <li><a href="ui-buttons.html">Buttons</a></li>
                                                        <li><a href="ui-buttons-group.html">Button Group</a></li>
                                                        <li><a href="ui-breadcrumb.html">Breadcrumb</a></li>
                                                        <li><a href="ui-cards.html">Card</a></li>
                                                        <li><a href="ui-carousel.html">Carousel</a></li>
                                                        <li><a href="ui-colors.html">Colors</a></li>
                                                        <li><a href="ui-dropdowns.html">Dropdowns</a></li>
                                                        <li><a href="ui-grid.html">Grid</a></li>
                                                        <li><a href="ui-images.html">Images</a></li>
                                                        <li><a href="ui-lightbox.html">Lightbox</a></li>
                                                        <li><a href="ui-media.html">Media</a></li>
                                                        <li><a href="ui-modals.html">Modals</a></li>
                                                        <li><a href="ui-offcanvas.html">Offcanvas</a></li>
                                                        <li><a href="ui-pagination.html">Pagination</a></li>
                                                        <li><a href="ui-popovers.html">Popovers</a></li>
                                                        <li><a href="ui-progress.html">Progress</a></li>
                                                        <li><a href="ui-placeholders.html">Placeholders</a></li>
                                                        <li><a href="ui-rangeslider.html">Range Slider</a></li>
                                                        <li><a href="ui-spinner.html">Spinner</a></li>
                                                        <li><a href="ui-sweetalerts.html">Sweet Alerts</a></li>
                                                        <li><a href="ui-nav-tabs.html">Tabs</a></li>
                                                        <li><a href="ui-toasts.html">Toasts</a></li>
                                                        <li><a href="ui-tooltips.html">Tooltips</a></li>
                                                        <li><a href="ui-typography.html">Typography</a></li>
                                                        <li><a href="ui-video.html">Video</a></li>
                                                        <li><a href="ui-sortable.html">Sortable</a></li>
                                                        <li><a href="ui-swiperjs.html">Swiperjs</a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>Advanced UI</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="ui-ribbon.html">Ribbon</a></li>
                                                        <li><a href="ui-clipboard.html">Clipboard</a></li>
                                                        <li><a href="ui-drag-drop.html">Drag & Drop</a></li>
                                                        <li><a href="ui-rangeslider.html">Range Slider</a></li>
                                                        <li><a href="ui-rating.html">Rating</a></li>
                                                        <li><a href="ui-text-editor.html">Text Editor</a></li>
                                                        <li><a href="ui-counter.html">Counter</a></li>
                                                        <li><a href="ui-scrollbar.html">Scrollbar</a></li>
                                                        <li><a href="ui-stickynote.html">Sticky Note</a></li>
                                                        <li><a href="ui-timeline.html">Timeline</a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>Charts</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="chart-apex.html">Apex Charts</a></li>
                                                        <li><a href="chart-c3.html">Chart C3</a></li>
                                                        <li><a href="chart-js.html">Chart Js</a></li>
                                                        <li><a href="chart-morris.html">Morris Charts</a></li>
                                                        <li><a href="chart-flot.html">Flot Charts</a></li>
                                                        <li><a href="chart-peity.html">Peity Charts</a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>Icons</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="icon-fontawesome.html">Fontawesome Icons</a></li>
                                                        <li><a href="icon-feather.html">Feather Icons</a></li>
                                                        <li><a href="icon-ionic.html">Ionic Icons</a></li>
                                                        <li><a href="icon-material.html">Material Icons</a></li>
                                                        <li><a href="icon-pe7.html">Pe7 Icons</a></li>
                                                        <li><a href="icon-simpleline.html">Simpleline Icons</a></li>
                                                        <li><a href="icon-themify.html">Themify Icons</a></li>
                                                        <li><a href="icon-weather.html">Weather Icons</a></li>
                                                        <li><a href="icon-typicon.html">Typicon Icons</a></li>
                                                        <li><a href="icon-flag.html">Flag Icons</a></li>
                                                        <li><a href="icon-tabler.html">Tabler Icons</a></li>
                                                        <li><a href="icon-bootstrap.html">Bootstrap Icons</a></li>
                                                        <li><a href="icon-remix.html">Remix Icons</a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>Forms</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li className="submenu submenu-two">
                                                            <a href="javascript:void(0);">Form Elements<span className="menu-arrow inside-submenu"></span></a>
                                                            <ul>
                                                                <li><a href="form-basic-inputs.html">Basic Inputs</a></li>
                                                                <li><a href="form-checkbox-radios.html">Checkbox & Radios</a></li>
                                                                <li><a href="form-input-groups.html">Input Groups</a></li>
                                                                <li><a href="form-grid-gutters.html">Grid & Gutters</a></li>
                                                                <li><a href="form-select.html">Form Select</a></li>
                                                                <li><a href="form-mask.html">Input Masks</a></li>
                                                                <li><a href="form-fileupload.html">File Uploads</a></li>
                                                            </ul>
                                                        </li>
                                                        <li className="submenu submenu-two">
                                                            <a href="javascript:void(0);">Layouts<span
                                                                    className="menu-arrow inside-submenu"></span></a>
                                                            <ul>
                                                                <li><a href="form-horizontal.html">Horizontal Form</a></li>
                                                                <li><a href="form-vertical.html">Vertical Form</a></li>
                                                                <li><a href="form-floating-labels.html">Floating Labels</a></li>
                                                            </ul>
                                                        </li>
                                                        <li><a href="form-validation.html">Form Validation</a></li>
                                                        <li><a href="form-select2.html">Select2</a></li>
                                                        <li><a href="form-wizard.html">Form Wizard</a></li>
                                                        <li><a href="form-pickers.html">Form Picker</a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);"><span>Tables</span><span className="menu-arrow"></span></a>
                                                    <ul>
                                                        <li><a href="tables-basic.html">Basic Tables </a></li>
                                                        <li><a href="data-tables.html">Data Table </a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);"><span>Maps</span>
                                                        <span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li>
                                                            <a href="maps-vector.html">Vector</a>
                                                        </li>
                                                        <li>
                                                            <a href="maps-leaflet.html">Leaflet</a>
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li><a href="javascript:void(0);"><span>Documentation</span></a></li>
                                                <li><a href="javascript:void(0);"><span>Changelog v2.2.2</span></a></li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);"><span>Multi Level</span><span className="menu-arrow"></span></a>
                                                    <ul>
                                                    <li><a href="javascript:void(0);">Level 1.1</a></li>
                                                    <li className="submenu submenu-two"><a href="javascript:void(0);">Level 1.2<span className="menu-arrow inside-submenu"></span></a>
                                                    <ul>
                                                        <li><a href="javascript:void(0);">Level 2.1</a></li>
                                                        <li className="submenu submenu-two submenu-three"><a href="javascript:void(0);">Level 2.2<span className="menu-arrow inside-submenu inside-submenu-two"></span></a>
                                                            <ul>
                                                                <li><a href="javascript:void(0);">Level 3.1</a></li>
                                                                <li><a href="javascript:void(0);">Level 3.2</a></li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                            </ul>
                                        </li>
                                        <li className="submenu">
                                            <a href="#">
                                                <i className="ti ti-settings-cog"></i><span>Settings</span>
                                                <span className="menu-arrow"></span>
                                            </a>
                                            <ul>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);"><span>General Settings</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="profile.html">Profile</a></li>
                                                        <li><a href="security.html">Security</a></li>
                                                        <li><a href="notifications.html">Notifications</a></li>
                                                        <li><a href="connected-apps.html">Connected Apps</a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>Website Settings</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="company-settings.html">Company Settings</a></li>
                                                        <li><a href="localization.html">Localization</a></li>
                                                        <li><a href="prefixes.html">Prefixes</a></li>
                                                        <li><a href="preference.html">Preference</a></li>
                                                        <li><a href="appearance.html">Appearance</a></li>
                                                        <li><a href="language.html">Language</a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>App Settings</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="invoice-settings.html">Invoice Settings</a></li>
                                                        <li><a href="printers.html">Printers</a></li>
                                                        <li><a href="custom-fields.html">Custom Fields</a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>System Settings</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="email-settings.html">Email Settings</a></li>
                                                        <li><a href="sms-gateways.html">SMS Gateways</a></li>
                                                        <li><a href="gdpr-cookies.html">GDPR Cookies</a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>Financial Settings</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="payment-gateways.html">Payment Gateways</a></li>
                                                        <li><a href="bank-accounts.html">Bank Accounts</a></li>
                                                        <li><a href="tax-rates.html">Tax Rates</a></li>
                                                        <li><a href="currencies.html">Currencies</a></li>
                                                    </ul>
                                                </li>
                                                <li className="submenu">
                                                    <a href="javascript:void(0);">
                                                        <span>Other Settings</span><span className="menu-arrow"></span>
                                                    </a>
                                                    <ul>
                                                        <li><a href="storage.html">Storage</a></li>
                                                        <li><a href="ban-ip-address.html">Ban IP Address</a></li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </li>

                    <li className="nav-item nav-list">
                        <ul className="nav">
                            {/*<li>
                                <div>
                                    <Link to="#" className="btn btn-icon border btn-menubar btnFullscreen">
                                        <i className="ti ti-maximize"></i>
                                    </Link>
                                </div>
                            </li>
                            <li className="dark-mode-list">
                                <Link to="javascript:void(0);" id="dark-mode-toggle" className="dark-mode-toggle">
                                    <i className="ti ti-sun light-mode active"></i>
                                    <i className="ti ti-moon dark-mode"></i>
                                </Link>
                            </li>
                            <li className="nav-item dropdown">
                                <Link to="javascript:void(0);" className="btn btn-header-list" data-bs-toggle="dropdown">
                                    <i className="ti ti-layout-grid-add"></i>
                                </Link>
                                <div className="dropdown-menu dropdown-menu-end menus-info">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <ul className="menu-list">
                                                <li>
                                                    <Link to="contacts.html">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-violet">
                                                                <i className="ti ti-user-up"></i>
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Contacts</p>
                                                                <span>Add New Contact</span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="pipeline.html">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-green">
                                                                <i className="ti ti-timeline-event-exclamation"></i>
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Pipline</p>
                                                                <span>Add New Pipline</span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="activities.html">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-pink">
                                                                <i className="ti ti-bounce-right"></i>
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Activities</p>
                                                                <span>Add New Activity</span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="analytics.html">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-info">
                                                                <i className="ti ti-analyze"></i>
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Analytics</p>
                                                                <span>Shows All Information</span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="projects.html">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-danger">
                                                                <i className="ti ti-atom-2"></i>
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Projects</p>
                                                                <span>Add New Project</span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6">
                                            <ul className="menu-list">
                                                <li>
                                                    <Link to="deals.html">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-info">
                                                                <i className="ti ti-medal"></i>
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Deals</p>
                                                                <span>Add New Deals</span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="leads.html">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-secondary">
                                                                <i className="ti ti-chart-arcs"></i>
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Leads</p>
                                                                <span>Add New Leads</span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="companies.html">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-tertiary">
                                                                <i className="ti ti-building-community"></i>
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Company</p>
                                                                <span>Add New Company</span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="tasks.html">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-success">
                                                                <i className="ti ti-list-check"></i>
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Tasks</p>
                                                                <span>Add New Task</span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link to="campaign.html">
                                                        <div className="menu-details">
                                                            <span className="menu-list-icon bg-purple">
                                                                <i className="ti ti-brand-campaignmonitor"></i>
                                                            </span>
                                                            <div className="menu-details-content">
                                                                <p>Campaign</p>
                                                                <span>Add New Campaign</span>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="nav-item">
                                <a href="faq.html" className="btn btn-help">
                                    <i className="ti ti-help-hexagon"></i>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a href="lead-reports.html" className="btn btn-chart-pie">
                                    <i className="ti ti-chart-pie"></i>
                                </a>
                            </li>*/}
                        </ul>
                    </li>                    

                    {/*<li className="nav-item dropdown nav-item-box">
                        <Link to="javascript:void(0);" className="nav-link" data-bs-toggle="dropdown">
                            <i className="ti ti-bell"></i>
                            <span className="badge rounded-pill">13</span>
                        </Link>
                        <div className="dropdown-menu dropdown-menu-end notification-dropdown">
                            <div className="topnav-dropdown-header">
                                <h4 className="notification-title">Notifications</h4>
                            </div>
                            <div className="noti-content">
                                <ul className="notification-list">
                                    <li className="notification-message">
                                        <Link to="activities.html">
                                            <div className="media d-flex">
                                                <span className="avatar flex-shrink-0">
                                                    <img src="assets/img/profiles/avatar-02.jpg" alt="Profile" />
                                                    <span className="badge badge-info rounded-pill"></span>
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <p className="noti-details">Ray Arnold left 6 comments on Isla Nublar SOC2 compliance report</p>
                                                    <p className="noti-time">Last Wednesday at 9:42 am</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li className="notification-message">
                                        <Link to="activities.html">
                                            <div className="media d-flex">
                                                <span className="avatar flex-shrink-0">
                                                    <img src="assets/img/profiles/avatar-03.jpg" alt="Profile" />
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <p className="noti-details">Denise Nedry replied to Anna Srzand</p>
                                                    <p className="noti-sub-details">“Oh, I finished de-bugging the phones, but the system's compiling for eighteen minutes, or twenty.  So, some minor systems may go on and off for a while.”</p>
                                                    <p className="noti-time">Last Wednesday at 9:42 am</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                    <li className="notification-message">
                                        <Link to="activities.html">
                                            <div className="media d-flex">
                                                <span className="avatar flex-shrink-0">
                                                    <img alt="" src="assets/img/profiles/avatar-06.jpg" />
                                                </span>
                                                <div className="media-body flex-grow-1">
                                                    <p className="noti-details">John Hammond attached a file to Isla Nublar SOC2 compliance report</p>
                                                    <div className="noti-pdf">
                                                        <div className="noti-pdf-icon">
                                                            <span><i className="ti ti-chart-pie"></i></span>
                                                        </div>
                                                        <div className="noti-pdf-text">
                                                            <p>EY_review.pdf</p>
                                                            <span>2mb</span>
                                                        </div>
                                                    </div>
                                                    <p className="noti-time">Last Wednesday at 9:42 am</p>
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                            <div className="topnav-dropdown-footer">
                                <Link to="activities.html" className="view-link">View all</Link>
                                <Link to="javascript:void(0);" className="clear-link">Clear all</Link>
                            </div>
                        </div>
                    </li>*/}

                    <li className="nav-item dropdown has-arrow main-drop">
                        <div className="dropdown profile-dropdown d-flex align-items-center justify-content-center" ref={profiledropdownRef}>
                            <div className={showprofiledropdown ? "topbar-link drop-arrow-none position-relative show" : "topbar-link  drop-arrow-none position-relative"} onClick={handleShowProfileToggle} >
                                
                                <img src={userlogo} width="38" className="rounded-1 d-flex" alt="user-image" />

                                <span class="online text-success"><i class="ti ti-circle-filled d-flex bg-white rounded-circle border border-1 border-white"></i></span>
                                
                            </div>

                            {showprofiledropdown ?
                            <div class="dropdown-menu dropdown-menu-end dropdown-menu-md p-2 show" data-popper-placement="bottom-end" style={{ position: "absolute", inset: "0px 0px auto auto", margin: "0px", transform: "translate3d(0px, 60px, 0px)" }}>
                            
                                <div class="d-flex align-items-center bg-light rounded-3 p-2 mb-2">
                                    <img src={userlogo} class="rounded-circle" width="42" height="42" alt="Img" />
                                    <div class="ms-2">
                                        <p class="fw-medium text-dark mb-0">{loggedname}</p>
                                        <span class="d-block fs-13">Team Leader</span>
                                    </div>
                                </div>

                                <Link to="/team/profile" class="dropdown-item">
                                    <i class="ti ti-user-circle me-1 align-middle"></i>
                                    <span class="align-middle">Profile Settings</span>
                                </Link>

                                {/*<div class="form-check form-switch form-check-reverse d-flex align-items-center justify-content-between dropdown-item mb-0">
                                    <label class="form-check-label" for="notify"><i class="ti ti-bell"></i>Notifications</label>
                                    <input class="form-check-input me-0" type="checkbox" role="switch" id="notify" />
                                </div>

                                <Link to="" class="dropdown-item">
                                    <i class="ti ti-help-circle me-1 align-middle"></i>
                                    <span class="align-middle">Help &amp; Support</span>
                                </Link>

                                <Link to="" class="dropdown-item">
                                    <i class="ti ti-settings me-1 align-middle"></i>
                                    <span class="align-middle">Settings</span>
                                </Link>*/}            
                                
                                <div class="pt-2 mt-2 border-top">
                                    <button class="dropdown-item text-danger" onClick={handleLogout}>
                                        <i class="ti ti-logout me-1 fs-17 align-middle"></i>
                                        <span class="align-middle">Sign Out</span>
                                    </button>
                                </div>
                            </div>
                            :
                            <div class="dropdown-menu dropdown-menu-end dropdown-menu-md p-2" data-popper-placement="bottom-end" style={{ position: "absolute", inset: "0px 0px auto auto", margin: "0px", transform: "translate3d(0px, 60px, 0px)" }}>
                            
                                <div class="d-flex align-items-center bg-light rounded-3 p-2 mb-2">
                                    <img src={userlogo} class="rounded-circle" width="42" height="42" alt="Img" />
                                    <div class="ms-2">
                                        <p class="fw-medium text-dark mb-0">{loggedname}</p>
                                        <span class="d-block fs-13">Team Leader</span>
                                    </div>
                                </div>

                                <Link to="/team/profile" class="dropdown-item">
                                    <i class="ti ti-user-circle me-1 align-middle"></i>
                                    <span class="align-middle">Profile Settings</span>
                                </Link>

                                {/*<div class="form-check form-switch form-check-reverse d-flex align-items-center justify-content-between dropdown-item mb-0">
                                    <label class="form-check-label" for="notify"><i class="ti ti-bell"></i>Notifications</label>
                                    <input class="form-check-input me-0" type="checkbox" role="switch" id="notify" />
                                </div>

                                <Link to="" class="dropdown-item">
                                    <i class="ti ti-help-circle me-1 align-middle"></i>
                                    <span class="align-middle">Help &amp; Support</span>
                                </Link>

                                <Link to="" class="dropdown-item">
                                    <i class="ti ti-settings me-1 align-middle"></i>
                                    <span class="align-middle">Settings</span>
                                </Link>*/}            
                                
                                <div class="pt-2 mt-2 border-top">
                                    <button class="dropdown-item text-danger" onClick={handleLogout}>
                                        <i class="ti ti-logout me-1 fs-17 align-middle"></i>
                                        <span class="align-middle">Sign Out</span>
                                    </button>
                                </div>
                            </div>
                            }
                        </div>
                    </li>
                    {/*<li className="nav-item nav-item-email nav-item-box">
                        <div className="" style={{ cursor: "pointer" }} onClick={handleLogout}>
                            <svg  xmlns="http://www.w3.org/2000/svg"  width="34"  height="34"  viewBox="0 0 21 21"  fill="none"  stroke="currentColor"  strokeWidth="2"  strokeLinecap="round"  strokeLinejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-power">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                <path d="M7 6a7.75 7.75 0 1 0 10 0" />
                                <path d="M12 4l0 8" />
                            </svg>
                        </div>
                    </li>*/}
                </ul>
            </div>

            {/*<div className="dropdown mobile-user-menu">
                <a href="javascript:void(0);" className="nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i className="fa fa-ellipsis-v"></i></a>
                <div className="dropdown-menu">
                    <a className="dropdown-item" href="index-2.html">
                        <i className="ti ti-layout-2"></i> Dashboard
                    </a>
                    <a className="dropdown-item" href="profile.html">
                        <i className="ti ti-user-pin"></i> My Profile
                    </a>
                    <a className="dropdown-item" href="login.html">
                        <i className="ti ti-lock"></i> Logout
                    </a>
                </div>
            </div>*/}
        </div>
    )

}

export default Header;